import { BlocksChangeEvent } from 'blocks-nextjs/blocks-web-components/events';

export const displayInputValues = (
  isDisplayAlternative: boolean,
  firstInputValue: string,
  alternateValue: string
) => {
  return isDisplayAlternative ? alternateValue : firstInputValue;
};

export const setInputValue = (
  e: BlocksChangeEvent,
  setValue: (inputName: string, inputValue: string) => void,
  inputName = ''
) => {
  const inputValue = e.detail.value;
  setValue(inputName, inputValue);
};
